module.exports = __webpack_public_path__ + "static/media/nima_talking_tailor_dai.b73a87dc.png";